import React, { useState, useEffect } from 'react';
import 'font-awesome/css/font-awesome.min.css';
import '../../assets/stylesheet/layout.scss';
import '../../assets/stylesheet/insights.scss'
import DonutChart from '../../components/donutChart';
import RequestResponseTrends from '../../components/requestresponsetrends';
import DateRangePickerComponent from '../../components/date-range';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import baseUrl from '../../services/baseUrl';
import ApiRequest from '../../services/apiService';
import GetUserData from '../../utilities/getUserDetails';
import MyMultiSelectDropdown from "../../utilities/multiSelectInputType";
import SingleSelectSobDropDown from '../Dashboard/DropDownSelectSobInputType';
import SingleSelectTouchpointDropdown from '../Dashboard/DropDownSelectTouchpointInputType';
import ScreenLoader from '../../components/screenLoader';





function JourneyMetrics() {
    const [isScrolled, setIsScrolled] = useState(false);
    const handleScroll = () => {
        if (window.scrollY > 50) {
            setIsScrolled(true);
        } else {
            setIsScrolled(false);
        }
    };
    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);


    const [quickFilter, setQuickFilter] = useState(localStorage.getItem('quickFilter') || '');
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [projectFilter, setProjectFilter] = useState(localStorage.getItem('projectFilter') || "");
    const [projects, setProjects] = useState([]);
    const location = useLocation();
    const query = queryString.parse(location.search);
    const [requestResponseChartData, setRequestResponseChartData] = useState([]);
    const [requestReceivedData, setRequestReceivedData] = useState({});
    const [pieChartData, setPieChartData] = useState({});
    const [totalTableData, setTotalTableData] = useState({});
    const [frcTableData, setFrcTableData] = useState({});
    const [feedbackInvitationsTabledata, setFeedbackInvitationsTabledata] = useState({});
    const [feedbackReminderTabledata, setFeedbackReminderTabledata] = useState({});
    const [UniquePageViewTableData, setUniquePageViewTableData] = useState({});
    const [touchpointFilter, setTouchpointFilter] = useState(localStorage.getItem('touchpointFilter') || '');
    const [sobFilter, setSobFilter] = useState(localStorage.getItem('sobFilter') || '');
    const [isAllTouchPoints, setIsAllTouchpoints] = useState(
        (localStorage.getItem('touchpointFilter') || localStorage.getItem('isAllTouchpoints')) ? true : false
    );
    const [IsLoading, setIsLoading] = useState(false);


    const fetchData = async () => {
        setIsLoading(true);

        try {
            const params = new URLSearchParams({
                quickFilterRange: quickFilter,
                fromDate: localStorage.getItem('fromDate') || fromDate,
                toDate: localStorage.getItem('toDate') || toDate,
                projectFilter: projectFilter,
                userCode: GetUserData().UserCode,
                userRole: GetUserData().UserRole,
                touchpointFilter: touchpointFilter,
                sobFilter: sobFilter
            });
            const url = `${baseUrl()}/nps/GetJourneyMetricsData?${params.toString()}`;
            const response = await ApiRequest({ apiLink: url, method: 'GET' });
            if (response.Message === 'Success') {
                setIsLoading(false);

                setProjects(response.Data.Projects);
                setRequestResponseChartData(response.Data.RequestResponseChartDatas);
                setRequestReceivedData(response.Data.RequestRecivedTables);
                setPieChartData(response.Data.PieChartDatas);
                setTotalTableData(response.Data.TotalTables);
                setFrcTableData(response.Data.FRCTables);
                setFeedbackInvitationsTabledata(response.Data.FeedbackInvitationsTables);
                setFeedbackReminderTabledata(response.Data.FeedbackReminderTables);
                setUniquePageViewTableData(response.Data.UniquePageViews);
            } else {
                console.log('Failed to load data');
            }
        } catch (error) {
            console.error('Error fetching cloud data:', error);
        }
    };
    useEffect(() => {
        fetchData();
    }, [quickFilter, projectFilter, fromDate, toDate, sobFilter, touchpointFilter]);

    const handleDateRangeFilter = (startDate, endDate) => {
        if (startDate && endDate) {
            setFromDate(startDate.toISOString().split("T")[0]);
            setToDate(endDate.toISOString().split("T")[0]);
            setQuickFilter("");
        } else {
            setFromDate("");
            setToDate("");
        }
        localStorage.setItem('quickFilter', '');
        localStorage.setItem('fromDate', startDate.toISOString().split("T")[0]);
        localStorage.setItem('toDate', endDate.toISOString().split("T")[0]);
        // window.location.reload();
    };
    //QuickFilters
    const handleQuickFilter = async (event) => {
        const selectedValue = event.target.value;
        setFromDate('');
        setToDate('');
        setQuickFilter(selectedValue);
        localStorage.setItem('fromDate', '');
        localStorage.setItem('toDate', '');
        localStorage.setItem('quickFilter', selectedValue);
        window.location.reload();

    };

    const data = {
        labels: ['Mobile', 'Web',],
        datasets: [
            {
                label: 'Dataset 1',
                data: [pieChartData.MobileCount, pieChartData.WebCount],
                backgroundColor: [
                    '#04559f',
                    '#008000',
                    '#e31f2b',
                ],

                borderWidth: 0
            }
        ]
    };
    const throughtdata = {
        labels: ['SMS', 'WhatsApp', 'Others'],
        datasets: [
            {
                // label: 'Dataset 1',
                data: [pieChartData.SmsCount, pieChartData.WhatsappCount, pieChartData.OthersCount],
                backgroundColor: [
                    '#04559f',
                    '#008000',
                    '#e31f2b',
                ],

                borderWidth: 0
            }
        ]
    };
    const options = {
        plugins: {
          legend: {
            display: true, 
            position: 'bottom', 
            align: 'center', 
            labels: {
              padding: 15, 
              boxWidth: 7, 
              boxHeight: 7,
              usePointStyle: true,
            },
            title: {
              display: false,
              padding: 0,
            },
          },
          datalabels: {
            formatter: (value, ctx) => {
              const dataset = ctx.chart.data.datasets[0];
              const total = dataset.data.reduce((acc, val) => acc + val, 0);
              const percentage = ((value / total) * 100).toFixed(1);
              return `${percentage}%`;
            },
            color: '#fff',
          },
          tooltip: {
            callbacks: {
              label: function(tooltipItem) {
                return tooltipItem.label + ': ' + tooltipItem.raw;
              }
            }
          }
        },
        responsive: true,
        cutout: '50%' // This creates the donut effect
      };
    const typedata = {
        labels: ['Invitation', 'Reminders',],
        datasets: [
            {
                // label: 'Dataset 1',
                data: [pieChartData.InvitationCount, pieChartData.ReminderCount],
                backgroundColor: [
                    '#04559f',
                    '#008000',
                    '#e31f2b',
                ],

                borderWidth: 0
            }
        ]
    };

    const handleTouchpointFilter = (touchpoint) => {
        setTouchpointFilter(touchpoint);
        localStorage.setItem("touchpointFilter", touchpoint);
    }
    const handleSobFilter = (sob) => {
        setSobFilter(sob);
        localStorage.setItem("sobFilter", sob);
    }

    const handleAllTouchpointSelect = (isSelected) => {
        setSobFilter('');
        setIsAllTouchpoints(isSelected);
    }
    const handleProjectFilter = (event) => {
        const selectedOption = event.target.value;
        setProjectFilter(selectedOption === "Select Project" ? '' : selectedOption);
        localStorage.setItem('projectFilter', selectedOption === "Select Project" ? '' : selectedOption);
        localStorage.removeItem("sobFilter");
        localStorage.removeItem("touchpointFilter");
        window.location.reload();
    };
    return (
        <>
            {IsLoading ? (
                <div className="screenLoader">
                    <ScreenLoader />
                </div>
            ) : (
                <section className='container-fluid'>
                    <div className='Page-title d-flex align-items-center mb-1'>
                        <h3 className='mb-2'>Journey Metrics</h3>
                        <div className='me-1 ms-1 mt-1'>
                                <div className="did-floating-label-content me-1 mb-0">
                                    <select
                                        className="did-floating-select w-150px h-300"
                                        value={projectFilter}
                                        onChange={handleProjectFilter}
                                    >
                                        {/* <option value="">Select Project</option> */}
                                        {projects.map((project) => (
                                            <option key={project.ProjectId} value={project.ProjectId}>{project.ProjectName}</option>
                                        ))}
                                    </select>
                                    <label className="did-floating-label">
                                        Project Filter
                                    </label>
                                </div>
                            </div>
                        <div
                            className="did-floating-label-content mb-0">
                            <SingleSelectSobDropDown
                                onSobSelect={handleSobFilter}
                                onAllTouchpointSelect={handleAllTouchpointSelect}
                            />
                        </div>
                        <div
                            className={
                                (!isAllTouchPoints)
                                    ? "d-none did-floating-label-content mb-0"
                                    : "did-floating-label-content mb-0"
                            }>
                            <SingleSelectTouchpointDropdown
                                onTouchPointSelect={handleTouchpointFilter}
                            />
                        </div>
                        <div className='card-option ms-auto d-flex mt-1 pb-1'>
                            <div className="did-floating-label-content me-2 mb-0">
                                <select
                                    className="did-floating-select w-100px h-30"
                                    value={quickFilter}
                                    onChange={handleQuickFilter}
                                >
                                    <option value={""}>Select Filter</option>
                                    <option>FTD</option>
                                    <option>WTD</option>
                                    <option>MTD</option>
                                    <option>QTD</option>
                                    <option>YTD</option>
                                </select>
                                <label className="did-floating-label">
                                    Quick Filter
                                </label>
                            </div>
                            <div className='did-floating-label-content mb-0'>
                                <DateRangePickerComponent
                                    onRangeSelect={handleDateRangeFilter}
                                    quickFilter={quickFilter}
                                />
                            </div>
                        </div>
                    </div>
                    {/* request /response chart */}
                    <div className='row g-2 mb-2'>
                        <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                            <div className='card'>
                                <div className='card-body pt-1 pb-1'>
                                    <h4 className='page-sub-title'>Request Vs Response Trends</h4>
                                    <div className='card-content'>
                                        <div style={{ height: '250px', width: '100%' }}>
                                            {/* <DonutChart data={data} /> */}
                                            <RequestResponseTrends chartData={requestResponseChartData} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* chart area */}
                    <div className='row g-2 mb-2'>
                        <div className='col-14 col-sm-8 col-md-6 col-lg-6 col-xl-6'>
                            <div className='card'>
                                <div className='card-body pt-1 pb-1'>
                                    <h4 className='page-sub-title'>Responses - Sms, WhatsApp & Others</h4>
                                    <div className='card-content'>
                                        <div style={{ height: '250px', width: '100%' }}>
                                            <DonutChart data={throughtdata} options={options} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-14 col-sm-8 col-md-6 col-lg-6 col-xl-6'>
                            <div className='card'>
                                <div className='card-body pt-1 pb-1'>
                                    <h4 className='page-sub-title'>Responses - Invitation, Reminders</h4>
                                    <div className='card-content'>
                                        <div style={{ height: '250px', width: '100%' }}>
                                            <DonutChart data={typedata} options={options}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    {/* grid details area*/}
                    <div className='row g-2 mb-2'>

                        <div className='col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3'>
                            <div className='card mb-2'>
                                <div className='card-body pt-1 pb-2'>
                                    <h4 className='page-sub-title mb-2'>Request Received</h4>
                                    <div className='row'>
                                        <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-2'>
                                            <div className='table-responsive custom-table'>
                                                <table className='table table-sm table-bordered mb-0'>
                                                    <tbody>
                                                        <tr>
                                                            <td><strong>Requests</strong></td>
                                                            <td className='text-end'>{requestReceivedData.Requests}</td>
                                                        </tr>
                                                        <tr>
                                                            <td><strong>Duplicates</strong></td>
                                                            <td className='text-end'>NA</td>
                                                        </tr>
                                                        <tr>
                                                            <td><strong>Phone Numbers</strong></td>
                                                            <td className='text-end'>NA</td>
                                                        </tr>
                                                        <tr>
                                                            <td><strong>Phone Numbers (Incorrect)</strong></td>
                                                            <td className='text-end'>NA</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='card mb-2'>
                                <div className='card-body pt-1 pb-2'>
                                    <h4 className='page-sub-title mb-2'>Total</h4>
                                    <div className='row'>
                                        <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-2'>
                                            <div className='table-responsive custom-table'>
                                                <table className='table table-sm table-bordered mb-0'>
                                                    <tbody>
                                                        <tr>
                                                            <td><strong>People Contacted</strong></td>
                                                            <td className='text-end'>{totalTableData.PeopleContacted}</td>
                                                        </tr>
                                                        <tr>
                                                            <td><strong>Responses</strong></td>
                                                            <td className='text-end'>{totalTableData.Responses}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='card mb-2'>
                                <div className='card-body pt-1 pb-2'>
                                    <h4 className='page-sub-title mb-2'>Feedback Responded Channels</h4>
                                    <div className='row'>
                                        <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-2'>
                                            <div className='table-responsive custom-table'>
                                                <table className='table table-sm table-bordered mb-0'>
                                                    <tbody>
                                                        <tr>
                                                            <td><strong>SMS</strong></td>
                                                            <td className='text-end'>{frcTableData.SMSCount}</td>
                                                        </tr>
                                                        <tr>
                                                            <td><strong>Others</strong></td>
                                                            <td className='text-end'>{frcTableData.OthersCount}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className='col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3'>
                            <div className='card'>
                                <div className='card-body pt-1 pb-2'>
                                    <h4 className='page-sub-title mb-2'>Feedback Invitations</h4>
                                    <div className='row'>
                                        <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                            <div className='table-responsive custom-table'>
                                                <table className='table table-sm table-bordered mb-0'>
                                                    <tbody>
                                                        <tr>
                                                            <td><strong>SMS Sent</strong></td>
                                                            <td className='text-end'>{feedbackInvitationsTabledata.SmsCount}</td>
                                                        </tr>
                                                        <tr>
                                                            <td><strong>Phone Numbers (Invaid)</strong></td>
                                                            <td className='text-end'>NA</td>
                                                        </tr>
                                                        <tr>
                                                            <td><strong>SMS (Bounced)</strong></td>
                                                            <td className='text-end'>NA</td>
                                                        </tr>
                                                        <tr>
                                                            <td><strong>SMS (Expired)</strong></td>
                                                            <td className='text-end'>NA</td>
                                                        </tr>
                                                        <tr>
                                                            <td><strong>People Contacted</strong></td>
                                                            <td className='text-end'>{feedbackInvitationsTabledata.PeopleContacted}</td>
                                                        </tr>
                                                        <tr>
                                                            <td><strong>SMS (Delivered)</strong></td>
                                                            <td className='text-end'>NA</td>
                                                        </tr>
                                                        <tr>
                                                            <td><strong>SMS (Opened)</strong></td>
                                                            <td className='text-end'>NA</td>
                                                        </tr>
                                                        <tr>
                                                            <td><strong>SMS (Responded)</strong></td>
                                                            <td className='text-end'>NA</td>
                                                        </tr>
                                                        <tr>
                                                            <td><strong>Response Rate %</strong></td>
                                                            <td className='text-end'>{feedbackInvitationsTabledata.ResponseRate}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3'>
                            <div className='card'>
                                <div className='card-body pt-1 pb-2'>
                                    <h4 className='page-sub-title mb-2'>Feedback Reminder</h4>
                                    <div className='row'>
                                        <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                            <div className='table-responsive custom-table'>
                                                <table className='table table-sm table-bordered mb-0'>
                                                    <tbody>
                                                        <tr>
                                                            <td><strong>SMS Sent</strong></td>
                                                            <td className='text-end'>{feedbackReminderTabledata.SmsCount}</td>
                                                        </tr>
                                                        <tr>
                                                            <td><strong>Phone Numbers (Invaid)</strong></td>
                                                            <td className='text-end'>NA</td>
                                                        </tr>
                                                        <tr>
                                                            <td><strong>SMS (Bounced)</strong></td>
                                                            <td className='text-end'>NA</td>
                                                        </tr>
                                                        <tr>
                                                            <td><strong>SMS (Expired)</strong></td>
                                                            <td className='text-end'>NA</td>
                                                        </tr>
                                                        <tr>
                                                            <td><strong>People Contacted</strong></td>
                                                            <td className='text-end'>{feedbackReminderTabledata.PeopleContacted}</td>
                                                        </tr>
                                                        <tr>
                                                            <td><strong>SMS (Delivered)</strong></td>
                                                            <td className='text-end'>NA</td>
                                                        </tr>
                                                        <tr>
                                                            <td><strong>SMS (Opened)</strong></td>
                                                            <td className='text-end'>NA</td>
                                                        </tr>
                                                        <tr>
                                                            <td><strong>SMS (Responded)</strong></td>
                                                            <td className='text-end'>NA</td>
                                                        </tr>
                                                        <tr>
                                                            <td><strong>Response Rate %</strong></td>
                                                            <td className='text-end'>{feedbackReminderTabledata.ResponseRate}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3'>
                            {/* <div className='card mb-2'>
                            <div className='card-body pt-1 pb-2'>
                                <h4 className='page-sub-title mb-2'>Devices</h4>
                                <div className='row'>
                                    <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-2'>
                                        <div className='table-responsive custom-table'>
                                            <table className='table table-sm table-bordered mb-0'>
                                                <tbody>
                                                    <tr>
                                                        <td><strong>Mobile</strong></td>
                                                        <td className='text-end'>46947 (97.60%)</td>
                                                    </tr>
                                                    <tr>
                                                        <td><strong>Desktop</strong></td>
                                                        <td className='text-end'>1154 (2.40%)</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                            <div className='card'>
                                <div className='card-body pt-1 pb-2'>
                                    <h4 className='page-sub-title mb-2'>Unique Page View</h4>
                                    <div className='row'>
                                        <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                            <div className='table-responsive custom-table'>
                                                <table className='table table-sm table-bordered mb-0'>
                                                    <thead>
                                                        <tr>
                                                            <th>Page Name</th>
                                                            <th className='text-nowrap'>No. of Views</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>NPS</td>
                                                            <td>{UniquePageViewTableData.NPS}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Sub Questions</td>
                                                            <td>NA</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Thank you page</td>
                                                            <td>NA</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Link expiry page</td>
                                                            <td>NA</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Response already submitted page</td>
                                                            <td>NA</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className='row g-2'>

                    </div>


                </section>
            )}
        </>
    )
}

export default JourneyMetrics;
